import { useEffect, useRef, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import { Box, Typography } from '@mui/material';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix default marker icon (webpack breaks default asset paths)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

function parseCoords(locationStr) {
  if (!locationStr) return null;
  const parts = locationStr.split(',').map(s => parseFloat(s.trim()));
  if (parts.length >= 2 && !Number.isNaN(parts[0]) && !Number.isNaN(parts[1])) {
    return { lat: parts[0], lng: parts[1] };
  }
  return null;
}

function FlyTo({ target }) {
  const map = useMap();
  const prev = useRef(null);
  useEffect(() => {
    if (!target) return;
    if (prev.current === target) return;
    prev.current = target;
    map.flyTo([target.lat, target.lng], 14, { duration: 1 });
  }, [map, target]);
  return null;
}

export default function MapComponent({ focusDevice }) {
  const [devices, setDevices] = useState([]);

  useEffect(() => {
    fetch('/api/admin/devices')
      .then(r => r.json())
      .then(j => setDevices(Array.isArray(j.devices) ? j.devices : []))
      .catch(() => {});
  }, []);

  const located = devices.filter(d => parseCoords(d.location));
  const center = located.length > 0
    ? [parseCoords(located[0].location).lat, parseCoords(located[0].location).lng]
    : [31.5, 35.0];

  return (
    <Box sx={{ height: 420, width: '100%', borderRadius: 2, overflow: 'hidden' }}>
      <MapContainer center={center} zoom={located.length > 0 ? 10 : 7} style={{ height: '100%', width: '100%' }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FlyTo target={focusDevice} />
        {located.map(d => {
          const { lat, lng } = parseCoords(d.location);
          return (
            <Marker key={d.wfmc} position={[lat, lng]}>
              <Popup>
                <Typography variant="caption" sx={{ fontWeight: 700, display: 'block' }}>{d.wfmc}</Typography>
                {d.project && <Typography variant="caption" sx={{ display: 'block' }}>{d.project}{d.site ? ` / ${d.site}` : ''}</Typography>}
                {d.last_version && <Typography variant="caption" sx={{ display: 'block', opacity: 0.7 }}>v{d.last_version}</Typography>}
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
    </Box>
  );
}